import { Paper } from "@mantine/core";

export const paperComponentSettings = Paper.extend({
  defaultProps: {
    withBorder: true,
  },
});
